import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ig_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register") && path !== "/") {
        localStorage.removeItem("ig_token");
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return fallback;
}

export function mediaSrc(url) {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export function hasRichText(html) {
  if (!html || typeof html !== "string") return false;
  return html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim().length > 0;
}

export function rewriteHtmlMedia(html) {
  if (!html) return html;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  let out = html.replace(/(src=["'])(\/api\/)/gi, `$1${base}$2`);
  out = out.replace(/<a\b([^>]*?)>/gi, (_, attrs) => {
    let a = attrs;
    if (!/\btarget\s*=/i.test(a)) a += ' target="_blank"';
    if (!/\brel\s*=/i.test(a)) a += ' rel="noopener noreferrer"';
    return `<a${a}>`;
  });
  return out;
}

export default api;
